<template>
    <div>
        <vs-row class="cardGeneral"  ref="content">
            <vs-col class="cardReportes pasos" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <vs-row style="align-items: flex-end !important">
                    <vs-col sm="12" lg="2">
                        <div class="imgAlumno">
                        <img :src="'/api/personas/' + personaId + '/avatar'" @error="setAltImg" alt="alumno">
                        </div>
                    </vs-col>
                    <vs-col sm="12" lg="10" class="p-2">
                        <vs-row>
                            <vs-col sm="12" lg="6">
                                <h5>{{alumno.nombre}}</h5>
                                <p class="mb-1">Matrícula: <span> <strong>{{alumno.matricula}}</strong></span></p>
                                <p class="mb-1">Grupo Administrativo (No. Lista): <span> <strong>{{alumno.grupo_administrativo}}</strong></span></p>
                            </vs-col>
                            <vs-col sm="12" lg="6">
                                <form autocomplete="off">
                                    <vs-select class="aqui" filter label-placeholder="Institución" :key="institucionId" v-model="institucion" v-if="listInstituciones.length" @input="onChangeInstitucion" :disabled="!listInstituciones.length" autocomplete="off">
                                        <template v-if="listInstituciones.length" autocomplete="off">
                                            <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id">
                                                {{option.text}}
                                            </vs-option>
                                        </template>
                                        <template v-else>
                                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                            </vs-option>
                                        </template>
                                    </vs-select>
                                </form>
                                <form autocomplete="off">
                                    <vs-select name="ciclo_escolar_id" class="mr-0 mt-2" filter label-placeholder="Ciclo Escolar" v-model="cicloEscolar"  :key="cicloId" :disabled="!listCiclos.length" >
                                        <template v-if="listCiclos.length">
                                            <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                                {{option.text}}
                                            </vs-option>
                                        </template>
                                        <template v-else>
                                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                            </vs-option>
                                        </template>
                                    </vs-select>
                                </form>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>


        <div class=" container">


        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Expediente </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Descarga</a>
          </li>

        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="row">
              <!-- :ref="index" -->
              <div v-for="(option, i) in documents" :key="i"  class="col-12">
                <div class="card expediente-digital mb-3" v-if="option.es_visible ==  'si' ">
                  <div class="card-body" v-if="option.requiere_respuesta == 'si'" >
                    <div class="header" >
                      <h5  class="card-title m-0 font-weight-bold">

                        <i class="fas fa-file-download"></i>

                        <span v-text="option.nombre" ></span>
                      </h5>



                    <div v-show="option && option.con_formato == 'no'&& option.expediente_digital != 'null'&& option.requiere_respuesta == 'si' && option.path != 'null'">

                      <label style="background: #46c93a;  width:100; border-radius: 5px; cursor:pointer;padding: 5px 15px; margin-bottom: 0"> <strong style="color:#fff">Subir Documento
                      </strong>
                          <input type="file" id="documento" :ref="getNombre(i)" @change="eventFile" @input="onupload(option.id, i, option.ciclo_escolar_id)" style="display:none"/>
                      </label>
                      <div v-if="option.expediente_digital == 'null'">
                        <vs-button
                          blank
                          @click="downloadS3(option.id)">
                          <strong>Descargar Documento</strong>
                        </vs-button>
                      </div>

                      <div v-if="option.requiere_respuesta == 'si'">
                        <div v-if="option.archivo === 'null' "> no hay !</div>
                        <div v-else>
                          <vs-button v-if="option.archivo === 'null'"
                              blank
                               @click="downloadContestada(option.id , option.archivo.persona_id)">
                              <strong>Descargar Documento</strong>
                            </vs-button>

                            <vs-button v-else-if="option.archivo !== null"
                                blank
                                 @click="downloadContestada(option.id , option.archivo.persona_id)">
                                <strong>Descargar Documento</strong>
                              </vs-button>
                        </div>
                      </div>
                    </div>


                    <div v-if="option && option.con_formato == 'no'&& option.requiere_respuesta == 'no' && option.path != 'null'">
                      <button type="button" class="btn btn-primary"  blank @click="downloadWithPath(option.id)">  Descargar Documento </button>

                    </div>

                    <div v-if="option && option.con_formato == 'si'">
                      <vs-button
                        blank
                         @click="downloadWithFormat(option.id)">
                        <strong>Descargar Documento</strong>
                      </vs-button>
                    </div>

                </div>
                <hr>
                  <div class="" v-if="option.es_visible ==  'si' ">
                       <p   v-text="option.descripcion" class="text-justify m-0" ></p>
                  </div>
                  <div class="text-right " v-if="option.requiere_respuesta == 'si' ">
                  <div v-if="option.archivo != null">
                    <strong>Ultima Actualizacion </strong>  <p v-text="option.archivo.updated_at.substring(0,10)"></p>
                  </div>
                  </div>
                  <!----
                <div v-if=" option.expediente_digital">
                  <p  v-if="option.expediente_digital.archivo" class="text-justify m-0" ></p>
                </div>-->
              </div>
            </div>
            </div>
            </div>
            </div>
          <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="row">
              <div v-for="(option, i) in documents" :key="i"  class="col-12">
                <div class="card expediente-digital mb-3" v-if="option.es_visible == 'si' ">
                  <div class="card-body" v-if="option.requiere_respuesta == 'no'">
                    <div class="header">
                      <h5  class="card-title m-0 font-weight-bold">

                        <i class="fas fa-file-download"></i>
                        <span v-text="option.nombre" ></span>
                      </h5>

                    <div v-if="option && option.con_formato != null && option.expediente_digital != 'null'&& option.requiere_respuesta == 'si' && option.path != 'null'">


                      <div v-if="option.expediente_digital == 'null'">
                        <vs-button
                          blank
                           @click="downloadS3(option.id)">
                          Descargar Documento
                        </vs-button>
                      </div>
                      <div v-if="option.requiere_respuesta != 'null' && option.expediente_digital != 'null' && option.path != 'null'">
                        <vs-button blank
                           @click="downloadContestada(option.expediente_digital.documento_id , option.expediente_digital.persona_id)">
                          Descargar Documento 
                        </vs-button>
                      </div>

                    </div>


                    <div v-if="option && option.con_formato == 'no'&& option.requiere_respuesta == 'no' && option.path != 'null'">
                      <button type="button" class="btn btn-primary" blank @click="downloadWithPath(option.id)">  Descargar Documento </button>

                    </div>

                    <div v-if="option && option.con_formato == 'si'">
                      <vs-button
                        blank
                         @click="downloadWithFormat(option.id)">
                        Descargar Documento
                      </vs-button>
                    </div>

                </div>
                <hr>
                  <div class="" v-if="option.es_visible ==  'si' ">
                       <p   v-text="option.descripcion" class="text-justify m-0" ></p>
                  </div>
                  <div class="text-right " v-if="option.requiere_respuesta == 'si' ">
                  <div v-if="option.archivo != null">
                    <strong>Ultima Actualizacion </strong>  <p v-text="option.archivo.updated_at.substring(0,10)"></p>
                  </div>
                  </div>
                  <!----
                <div v-if=" option.expediente_digital">
                  <p  v-if="option.expediente_digital.archivo" class="text-justify m-0" ></p>
                </div>-->
              </div>
            </div>
            </div>
            </div>
          </div>

        </div>
  </div>
    </div>

</template>


<script>
import cobranza from '../../../../api/requests/cobranza-persona.js'
import catalogos from '../../../../api/requests/catalogos.js'
    export default {
        props: [
          'personaId'
        ],
        data:() => ({
            institucion: '',
            listInstituciones:[],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            documents:[],
            documentInfo: {},
            listCiclos: [],
            cicloId: (new Date()).getTime(),
            programaDefault: '',
            headers: [],
            users: [],
            usersOptativas:[],
            promedios: [],
            promediosOptativos: [],
            promedio_materias: [],
            promedio_general:0,
            errorInstituto: false,
            errorCiclo: false,
            id_alumno: '',
            alumno: [],
            ruta: '',
            info: {},
            persona_id: '',
            documentId: '',
            id:'',
            informacion: [],
            infoUsers: [],
            params_configuracion: {},
            ruta: '',
            host: '',
            componentKey: 0,
            infoAlumno:[],
            infoCalif: [],
            infoCalifGen: [],
            crear: true,
            activeCalificacion: false,
            numeroAsentar: '',
            calif_nueva: '',
            alfa_nueva: '',
            noPermitir: false,
            botonCali: false,
            errorFields: [],
            permisos: [],
            listPrograma: [],
            hoy: '',
            tipoModificar:'',
            calificacionActual: '',
            modificar: {
                'calificacion': 'Calificación',
                'faltas': 'Faltas',
                'retardos': 'Retardos',
                'conducta': 'Conducta',
                'tareas_no_hechas': 'Tareas no hechas'
            },
          selectedFile: null,
        }),

        async created(){
            this.getInstitucioneDefault()
            this.getDocuments()
        },
      methods:{
        getNombre(index){
          const nombre = 'documento' + index
          return nombre
        },
        async getInstitucioneDefault () {
          
             let params = {
                "persona": this.personaId
            }
            const { data: response } = await catalogos.getInstitutosDefault(params) || {}
            const { opciones: info, default: val } = response || {}
            this.listInstituciones = info instanceof Object ?  Object.values(info) : []
            this.institucion = val
            this.institucionId = (new Date()).getTime()
            this.idInstitucion = btoa(this.institucion)
            this.onChangeInstitucion ()
        },
        async getCicloDefault() {
            let params = {
                "nivel_academico": this.nivel,
                "institucion_id": this.institucion,
                "persona_id": this.personaId
            }
            const { data: response } = await catalogos.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.listCiclos = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloId = (new Date()).getTime()


        },
        async getDocuments(){
            if(this.cicloEscolar){
              try {
                let params = {
                    "persona_id": this.personaId,
                    "ciclo_escolar_id": this.cicloEscolar,
                    "institucion_id": this.institucion,

                }
                const { data: response } = await catalogos.getExpepedienteDigital(params) || {}
                const { opciones: documentInfo } = response || {}


                this.documents = response
                  // console.log(this.documents)

                           } catch (error) {
                             this.documents = ''
                              console.log('error')
                           }
            }
        },
        async downloadS3(id){

            try {
              const url = '/panel/expediente-digital/descargar-archivo/'+ id +  '/' + this.personaId
                window.open(url)
            } catch (e) {
              console.log('downloadS3 try catch');
               console.log(e);
            }

        },
        async downloadContestada(id,persona_id){
          const vue = this
                const url = '/panel/expediente-digital/descargar-archivo/'+ id +  '/' + persona_id
                $.ajax({ url:'/panel/expediente-digital/descargar-archivo/'+ id +  '/' + persona_id, type:'HEAD', error: function() {
                    vue.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Archivo no encontrado'
                    })
                },
                success: function() {
                    window.open(url)
                    } });
        },
        async downloadWithPath(id){
          try {
              const url = '/expedienteDigital/' + id + '/descargar/'
              window.open(url)
          } catch (e) {
           logMyErrors(e);
         }
        },
        async downloadWithFormat(id){

          try {
            const url = '/documentos/pdf/'+ id + '/alumno/'+ this.personaId
                  window.open(url)
          } catch (e) {
            logMyErrors(e);
          }
        },
         eventFile(event){
            //  console.log(event)
          this.selectedFile = event.target.files[0]

        },

        async onupload(id, index)
          {
              const loading = this.$vs.loading({
                  target: this.$refs.content
              })
              const selectedFile = this.$refs['documento' + index][0].files[0]
            let form = new FormData();
            form.append('documento',selectedFile);
            form.append("ciclo_escolar_id", this.cicloEscolar)
            const vue = this
            axios.post('/panel/expediente-digital/cargar-archivo/'+ id + '/' + this.personaId, form)

            .then(res =>{
              //console.log(res)
              vue.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se cargó con éxito el documento.'
                    })
              loading.close()
              this.getDocuments();
            }, function(reason) {
              loading.close()
                console.log(reason); // Error!
              vue.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salio mal.',
                        text: 'Favor de comunicarse con el administrador.'
                    })
              });

          },
        async getProgramas () {
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion: this.institucion,
                id: this.personaId,
                ciclo_escolar: this.cicloEscolar,
            }

            if (this.nivel){
                params.nivel_academico = this.nivel
            }

            const { data: response } = await cobranza.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.listPrograma = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                }
            }
        },
        async listarCiclos () {
            if (this.institucion){
                try {
                    this.getCicloDefault()
                } catch (error) {

                }
            }else {
                this.listCiclos = []
            }
        },

        async listarDocuments () {
            if (this.institucion){
                try {
                    this.getDocuments()
                } catch (error) {

                }
            }else {
                this.listCiclos = []
            }
        },
        async getInfo () {
            if (this.personaId){
                try {
                    const persona_id = this.personaId
                    const params = {
                        "id": persona_id,
                        "institucion_id": this.institucion,
                        "ciclo_escolar_id": this.cicloEscolar,
                        "programa_id": this.programaDefault
                    }

                    const response = await cobranza.getInfoPersona(params)
                    this.alumno = response.data
                    this.nombre = response.data.nombre
                    this.idPersona = btoa(this.personaId)
                } catch (error) {

                }
            }
        },
        onChangeInstitucion () {
            this.listCiclos = []
            this.cicloEscolar = ''
            this.listarCiclos()
            this.listarDocuments()
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
      },
      watch:{
        cicloEscolar(){
            this.getProgramas()
            this.getInfo()
            this.getDocuments()
        },
        personaId(){
            this.getInstitucioneDefault()
            this.getDocuments()
        }
      },
    }
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }

    .imgAlumno{
        border-radius: 20%;
    }

    .imgAlumno img{
        width: 90%;
        margin-left: 3%;
        border-radius: 10px;
    }

    .logoInstitucion{
        width: 50%;
        background-color: blue;
        position: absolute;
        bottom: -25px;
        right: -30px;
	    border-radius: 50%;
    }

    .logoInstitucion > img{
        width: 100%;
        height: 80px;
        object-fit: cover;
    }


    .tablePDF{
        width: 100%;
        thead{
            border-bottom: 1px solid #F2F3F4;
            background: #F2F3F4;
        }
        thead tr th{
            padding: 10px 0;
        }

        tbody tr{
            border-bottom: 1px solid rgb(207, 207, 207);
        }
        tbody tr td{
            padding: 7px;
        }
        .centrarTexto{
            text-align: center;
        }

    }

</style>
<style>
    .pasos .md-steppers .md-steppers-navigation {
        box-shadow: none !important;
        color: red;
    }

    .vs-checkbox-label{
        margin-bottom: 0 !important;
    }
    input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: auto;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }

.pdfLetra{
    font-size: 10.5px;
    margin: 0;
}

.opcionPrincipalPDF{
    background: #E5E7E9;
    padding: 3px 5px;
}

.imgLogos img{
    width: 70%;
}

#footerBoleta {
   position:absolute;
   left:0px;
   bottom:0px;
   height:30px;
   width:100%;
   background:#999;
}
</style>
